module.exports = __webpack_public_path__ + "static/media/message.df53d13e.svg";